import { Component, Input, inject } from '@angular/core';
import {
  IonButton,
  IonContent,
  IonIcon,
  Platform,
} from '@ionic/angular/standalone';
import { addIcons } from 'ionicons';
import {
  logoAppleAppstore,
  logoGooglePlaystore,
  sadOutline,
} from 'ionicons/icons';

@Component({
  selector: 'app-version-mismatch',
  templateUrl: './version-mismatch.component.html',
  styleUrls: ['./version-mismatch.component.scss'],
  imports: [IonButton, IonIcon, IonContent],
})
export class VersionMismatchComponent {
  private platform = inject(Platform);

  @Input() minAppVersion: string;

  constructor() {
    addIcons({ sadOutline, logoAppleAppstore, logoGooglePlaystore });
  }

  get currentVersion(): string {
    return globalThis.appVersion;
  }

  isApplePlatform() {
    return this.platform.is('ios');
  }
}
